import { render, staticRenderFns } from "./CardStudentImage.vue?vue&type=template&id=013fcbf8&scoped=true&"
import script from "./CardStudentImage.vue?vue&type=script&lang=js&"
export * from "./CardStudentImage.vue?vue&type=script&lang=js&"
import style0 from "./CardStudentImage.vue?vue&type=style&index=0&id=013fcbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013fcbf8",
  null
  
)

export default component.exports